// extracted by mini-css-extract-plugin
module.exports = {"SuggestionBlock":"Suggestion_SuggestionBlock__veTBR","SuggestionLink":"Suggestion_SuggestionLink__3HF2k","SuggestionTemp":"Suggestion_SuggestionTemp__gRIio"};